export default __webpack_public_path__ + "static/media/gallery-wip-pre-paint_01.7fd19919.jpg";